import StudentRewardsIndex from '@/views/student-rewards/StudentRewardsIndex.vue';
import RewardPointsIndex from '@/views/student-rewards/settings/RewardPointsIndex.vue';
import AddRewardPoint from '@/views/student-rewards/settings/AddRewardPoint.vue';
import EditRewardPoint from '@/views/student-rewards/settings/EditRewardPoint.vue';
import StudentRewardStatistics from '@/views/student-rewards/StudentRewardStatistics.vue'
export default [
  {
    path: '/student-rewards',
    name: 'student-rewards.index',
    component: StudentRewardsIndex,
    meta: { 
      requiresAuth: true,
      title: 'student_rewards.breadcrumbs.index',
      requiredPerm: 'student_rewards.display',
    }
  },
   {
    path: '/student-rewards/statistics',
    name: 'student-rewards.statistics',
    component: StudentRewardStatistics, 
    meta: { 
      requiresAuth: true,
      title: 'student_rewards.breadcrumbs.statistics',
      requiredPerm: 'student_rewards.display',
    }
  },
  {
    path: '/settings/reward-points',
    name: 'settings.reward-points.index',
    component: RewardPointsIndex,
    meta: { 
      requiresAuth: true,
      title: 'reward_points.breadcrumbs.index',
      requiredPerm: 'reward_points.display',
    },
    children: [
  {
    path: '/settings/reward-points/add',
    name: 'settings.reward-points.add',
    component: AddRewardPoint,
    meta: { 
      requiresAuth: true,
      title: 'reward_points.breadcrumbs.add',
      requiredPerm: 'reward_points.create',
    }
  },
  {
    path: '/settings/reward-points/:id/edit',
    name: 'settings.reward-points.edit',
    component: EditRewardPoint,
    props: true,
    meta: { 
      requiresAuth: true,
      title: 'reward_points.breadcrumbs.edit',
      requiredPerm: 'reward_points.update',
    }
  }
    ]
  },

];